// A tippy element that doesn't show on mobile

import Tippy, { TippyProps } from '@tippyjs/react';
import { Children } from 'react';
import { useIsMobile } from '../../styles/themes';

export const MobileTippy = (props: { children: any } & TippyProps) => {
  const isMobile = useIsMobile();
  return isMobile ? props.children : <Tippy {...props}>{props.children}</Tippy>;
};
